export default "__VITE_ASSET__C1ZIfG98__"